import { Component } from '@angular/core';
import { CoachingService } from '../service/coaching.service';
import { CoachingMaster } from '../model/coaching-master';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { CoachingAttachmentComponent } from '../coaching-attachment/coaching-attachment.component';
import {ThemePalette} from '@angular/material/core';
import { UserProfileService } from '../service/user-profile.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { any } from 'video.js/dist/types/utils/events';
import {MatSelectModule} from '@angular/material/select';
import { Coaching } from '../model/coaching';
import { Location } from '@angular/common';
@Component({
  selector: 'app-coaching',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule, 
    MatButtonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    RouterLink,
    MatSelectModule,
  ],
  templateUrl: './coaching.component.html',
  styleUrl: './coaching.component.css'
})
export class CoachingComponent {
  color : ThemePalette = 'accent';
  isLoading = false;
  browserLangToUse = '';
  constructor(
    public dialog: MatDialog,
    private coachingService: CoachingService,
    private userProfileService: UserProfileService,
    translate: TranslateService,
    private location: Location,
  ) { 
    translate.setDefaultLang('en');
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    translate.use(browserLangToUse);
    this.browserLangToUse = browserLangToUse;
  }
  coachingMaster!: CoachingMaster;
  coachingToShow!: Coaching[];
  apexId!:string;
  ngOnInit(): void {
    this.isLoading = true;
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      let apexId = localStorage.getItem("apexid");
      this.apexId = apexId!;
      if(apexId !== null){
        // this.apexId = apexId;
        this.pageInitialization(apexId);
      }
    }
    else{
      let overrideObject = JSON.parse(overrideObjectString);
      let apexId = overrideObject.apexid;
      this.apexId = apexId;
      this.pageInitialization(apexId);
    }
    
  }
  setAllOrYearFromSelect(value:any){ 
    if(value === 'all'){
      this.coachingToShow = this.coachingMaster.data.sort((a,b) => this.compare(a.coachingTime, b.coachingTime));
    }
    else{
      this.coachingToShow = this.coachingMaster.data.filter(e => e.coachingTime.substring(0, 4) === value).sort((a,b) => this.compare(a.coachingTime, b.coachingTime));
    }
  }
  yearArray: any[] = [];
  selectedYear = new Date().getFullYear().toString();
  private pageInitialization(apexId:string): void {
    this.yearArray = [];
    
    this.coachingService.getcoaching(apexId).subscribe(responseCoachingMaster => {        
      this.coachingMaster = responseCoachingMaster;
      if(this.coachingMaster.totalCount > 0){
        for (const coaching of this.coachingMaster.data){
          let year = coaching.coachingTime.substring(0, 4);
          if(this.yearArray.some(e => e.textValue === year)){

          }
          else{
            this.yearArray.push({ textValue: year, textString: year });
          }
        }
      }
      this.yearArray.sort((a, b) => {return b.textValue - a.textValue ;});
      this.yearArray.unshift({ textValue: 'all', textString: 'all' });

      this.coachingToShow = this.coachingMaster.data.filter(e => e.coachingTime.substring(0, 4) === this.selectedYear).sort((a,b) => this.compare(a.coachingTime, b.coachingTime));
      this.isLoading = false;
    });
  }
  onOpenAttachment(coachingId:number): void {
    this.coachingService.getCoachingAttachment(coachingId).subscribe(responseAttachment => {
      const a = document.createElement('a');
      document.body.appendChild(a);
      const blob: any = new Blob([responseAttachment], { type: 'octet/stream' });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `coaching-${coachingId}-attachment.json`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
  openDialog(kpi:any) {
    this.dialog.open(CoachingAttachmentComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        kpi: kpi,
      },
    });
  }
  formatDate(dateString:string): string{
    // return new Date(dateString).toLocaleString();
    return dateString.split('T')[0].substring(0,10);
  }
  compare( a:string, b:string ) {
    if ( a < b ){
      return 1;
    }
    if ( a > b ){
      return -1;
    }
    return 0;
  }
  backClicked() {
    this.location.back();
  }
}
